import React from 'react';
import { Card, Icon, Stack, Typography } from '@mui/material';
import { pathToTab } from '../Tabs';
import { useAppSelector } from '../../store/hooks';

const TabHeader: React.FC<{ customTitle?: string; customDesc?: string; customIcon?: React.ReactNode }> = ({
	customTitle,
	customDesc,
	customIcon,
}) => {
	const selectedTab = useAppSelector((state) => state.tab.currentTab);
	const tabData = pathToTab(selectedTab || '');
	return (
		<Card variant="elevation" elevation={10} sx={{ width: '100%', display: 'flex' }}>
			<Stack direction="row" alignItems="center" gap={2} width={'100%'} padding={2.5}>
				<Stack>
					<Typography variant="h5" component="div">
						<b>{customTitle ?? tabData.name}</b>
					</Typography>
					<Typography variant="body2" sx={{ color: 'text.secondary' }}>
						{customDesc ?? tabData.helpText}
					</Typography>
				</Stack>
				{customIcon ?? <Icon component={tabData.icon} sx={{ ml: 'auto', mr: '1%' }} fontSize={'large'} />}
			</Stack>
		</Card>
	);
};

export default TabHeader;
